import type { GlobalConfig } from '@atlassian/jira-servicedesk-insight-global-configuration-store/src/common/types.tsx';
import type { AssetsPermissionResponse } from './types.tsx';

export const transformAssetsPermissionResponse = (
	response: GlobalConfig,
	apiCallSuccess: boolean,
): AssetsPermissionResponse => {
	return {
		isAssetsAdmin: response.insightAdministrator,
		isLicensedAssetsUser: apiCallSuccess,
	};
};

export const getAssetsGlobalConfigUrl = (workspaceId: string) => {
	return __SERVER__
		? '/api/v1/global/config'
		: `/gateway/api/jsm/assets/workspace/${workspaceId}/v1/global/config`;
};
